import { QueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import Router from "next/router";

import { getDomain } from "./cookies.core";
import { post } from "./fetch.core";
import { getShopId } from "./shop.core";

export const PwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_\-!@#\$%\^&\*]).{8,}$/;
export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function useShopId() {
  return getShopId();
}

export function getLoginToken() {
  return Cookies.get("loginTokenAdmin");
}

export function removeLoginTokenAndShopId() {
  Cookies.remove("loginTokenAdmin", { domain: getDomain() });
  Cookies.remove("shopId", { domain: getDomain() });
  forceLogin();
}

export function forceLogin() {
  if (getLoginToken() === undefined) {
    if (!window.location.href.match(/\/login/)) {
      Router.push("/login");
    }
  }
}

export function redirectIfLogined() {
  if (getLoginToken() !== undefined) {
    Router.push("/");
  }
}

export async function performLogin(data: any, queryClient: QueryClient) {
  const { route } = Router.query;

  if (!(await login(data, queryClient))) {
    return false;
  }

  if (route) {
    Router.push(route.toString());
  } else {
    Router.push("/");
  }
}

async function login(data: any, queryClient: QueryClient) {
  let response = await fetch(process.env.NEXT_PUBLIC_URL_ROOT + "/admin/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const content = await response.json();

  if (response.status !== 200) {
    return false;
  }

  Cookies.set("loginTokenAdmin", content.token, {
    domain: getDomain(),
    expires: 365,
    sameSite: "strict",
  });

  queryClient.invalidateQueries({ queryKey: ["me"] });
  queryClient.invalidateQueries({ queryKey: ["shopList"] });

  return true;
}

export async function logout(queryClient: QueryClient) {
  Cookies.remove("loginTokenAdmin", { domain: getDomain() });
  Cookies.remove("shopId", { domain: getDomain() });

  queryClient.invalidateQueries({ queryKey: ["me"] });

  window.location.href = "/login";
}

export async function requestResetPwd(data: any) {
  const response = await fetch(process.env.NEXT_PUBLIC_URL_ROOT + "/admin/requestResetPwd", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (response.status !== 200) {
    return false;
  }

  return true;
}

export async function resetPwd(data: any) {
  const response = await fetch(process.env.NEXT_PUBLIC_URL_ROOT + "/admin/resetPwd", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (response.status !== 200) {
    return false;
  }

  return true;
}

export async function changePassword(data: any) {
  await post(`/admin/changePwd`, data);
}
